<template>
  <div class="wrapper">
    <div class="CTAInsurance-info"></div>
  </div>
</template>

<script>
  export default {
    name: "CTAInsurance",
    data() {
      return {
      }
    },
    methods: {

    },
    mounted() {

    }
  }
</script>

<style scoped>
  .CTAInsurance-info{
    position: relative;
    max-height: 43.0625rem;
    padding-top: 35%;
    background: url("../../../static/images/product/CTAInsurance.png") no-repeat center / cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/CTAInsurance.vue